/**
 * The console's taxonomy, in visual order.
 *
 * Grouped by what an operator is DOING rather than by which table the data
 * lives in: "Queues" is everything with a backlog somebody has to work
 * through, and it sits directly under Overview because that is the work.
 * Corpus and People are reference — you go there when a queue item sends
 * you, or when you are looking something up.
 *
 * `badgeKey` names a field on `GET /admin/reports/counts`. The Sidebar
 * merges the live counts in; nothing here hardcodes a number.
 */
export type BadgeKey =
  | "openReports"
  | "pendingProposals"
  | "pendingCorrections"
  | "newFeedback"
  | "failedPhotos";

export interface NavItem {
  to: string;
  label: string;
  /** Exact match, so a prefix route does not light up its parent too. */
  exact?: boolean;
  badgeKey?: BadgeKey;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV: NavGroup[] = [
  {
    label: "Overview",
    items: [
      { to: "/", label: "Dashboard", exact: true },
      { to: "/goals", label: "Goals" },
      { to: "/cities", label: "Cities" },
    ],
  },
  {
    label: "Queues",
    items: [
      { to: "/reports", label: "Reports", badgeKey: "openReports" },
      { to: "/proposals", label: "Proposals", badgeKey: "pendingProposals" },
      {
        to: "/corrections",
        label: "Corrections",
        badgeKey: "pendingCorrections",
      },
      { to: "/feedback", label: "Feedback", badgeKey: "newFeedback" },
    ],
  },
  {
    label: "Corpus",
    items: [
      { to: "/cafes", label: "Cafes" },
      { to: "/reviews", label: "Reviews" },
    ],
  },
  {
    label: "People",
    items: [{ to: "/users", label: "People" }],
  },
  {
    label: "System",
    items: [
      { to: "/ops", label: "Ops", badgeKey: "failedPhotos" },
      { to: "/audit", label: "Audit log" },
    ],
  },
];
